export default "__VITE_ASSET__BrI$cBEm__"